(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-footer"]) return;
  try {
    
const cpFooterWide = window.matchMedia('(min-width: 1100px)');
function cpSyncFooterMenus() {
  document.querySelectorAll('[data-cp-footer-menu]').forEach((menu) => {
    menu.open = cpFooterWide.matches;
  });
}
cpSyncFooterMenus();
cpFooterWide.addEventListener('change', cpSyncFooterMenus);
document.addEventListener('shopify:section:load', cpSyncFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-header"]) return;
  try {
    
(() => {
  let activeTrigger;
  const menu = () => document.getElementById('CpMobileMenu');
  const syncViewport = () => {
    const dialog = menu();
    if (dialog?.open) dialog.style.setProperty('--cp-menu-viewport-height', `${Math.round(window.visualViewport?.height ?? window.innerHeight)}px`);
  };
  window.visualViewport?.addEventListener('resize', syncViewport);
  window.addEventListener('resize', syncViewport);
  const closeMenu = () => {
    const dialog = menu();
    if (dialog?.open) dialog.close();
    document.body.classList.remove('cp-menu-is-open');
    document.querySelectorAll('[data-cp-menu-open]').forEach(button => button.setAttribute('aria-expanded','false'));
  };
  const showSearch = (dialog, visible) => {
    const form = dialog.querySelector('#CpDrawerSearch');
    form.hidden = !visible;
    const toggle = dialog.querySelector('[data-cp-menu-search-toggle]');
    toggle.setAttribute('aria-expanded', String(visible));
    if (visible) form.querySelector('input[type="search"]').focus({preventScroll:true});
    else toggle.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cp-menu-open]');
    if (trigger) {
      const dialog = menu();
      if (!dialog) return;
      activeTrigger = trigger;
      if (!dialog.open) {
        dialog.showModal();
        dialog.scrollTop = 0;
      }
      syncViewport();
      document.body.classList.add('cp-menu-is-open');
      document.querySelectorAll('[data-cp-menu-open]').forEach(button => button.setAttribute('aria-expanded','true'));
      if (trigger.hasAttribute('data-cp-menu-start-search')) showSearch(dialog,true);
      return;
    }
    if (event.target.closest('[data-cp-menu-close]')) closeMenu();
    const searchToggle = event.target.closest('[data-cp-menu-search-toggle]');
    if (searchToggle) {
      const dialog = menu();
      showSearch(dialog,dialog.querySelector('#CpDrawerSearch').hidden);
    }
    if (event.target.closest('.cp-menu-dialog a')) closeMenu();
    document.querySelectorAll('.cp-product-nav[open]').forEach(panel => {
      if (!panel.contains(event.target)) panel.open=false;
    });
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('.cp-menu-dialog')) return;
    document.body.classList.remove('cp-menu-is-open');
    document.querySelectorAll('[data-cp-menu-open]').forEach(button => button.setAttribute('aria-expanded','false'));
    event.target.style.removeProperty('--cp-menu-viewport-height');
    event.target.querySelectorAll('details[open]').forEach(detail => {detail.open=false});
    event.target.querySelector('#CpDrawerSearch').hidden=true;
    event.target.querySelector('[data-cp-menu-search-toggle]').setAttribute('aria-expanded','false');
    if (activeTrigger?.isConnected) activeTrigger.focus({preventScroll:true});
  },true);
  document.addEventListener('keydown', event => {
    if (event.key!=='Escape') return;
    if (menu()?.open) {event.preventDefault();closeMenu();return}
    document.querySelectorAll('.cp-product-nav[open]').forEach(panel => {panel.open=false;panel.querySelector('summary').focus()});
  });
  window.matchMedia('(min-width: 901px)').addEventListener('change', event => {if(event.matches)closeMenu()});
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('.cp-menu-dialog')) document.body.classList.remove('cp-menu-is-open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-paper-project"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-paper-project]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const process = root.querySelector('[data-paper-process]');
      const play = process.querySelector('[data-process-play]');
      const buttons = [...process.querySelectorAll('[data-process-step]')];
      const panels = [...process.querySelectorAll('[data-step-panel]')];
      let step = 1;
      let timer = null;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const setStep = n => {
        step = n;process.dataset.step = String(n);
        buttons.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.processStep) === n)));
        panels.forEach(p => p.classList.toggle('is-active', Number(p.dataset.stepPanel) === n));
      };
      const stop = () => {
        clearInterval(timer);timer = null;process.dataset.playing = 'false';
        play.setAttribute('aria-pressed','false');play.querySelector('[data-play-text]').textContent = reduced.matches ? play.dataset.nextLabel : play.dataset.playLabel;
      };
      process.dataset.ready = 'true';
      if(reduced.matches)play.querySelector('[data-play-text]').textContent = play.dataset.nextLabel;
      buttons.forEach(b => b.addEventListener('click', () => {stop();setStep(Number(b.dataset.processStep));}));
      play.addEventListener('click', () => {
        if (timer) {stop();return;}
        if (reduced.matches) {setStep(step === 6 ? 1 : step + 1);return;}
        if(step === 6)setStep(1);
        process.dataset.playing = 'true';play.setAttribute('aria-pressed','true');
        play.querySelector('[data-play-text]').textContent = play.dataset.pauseLabel;
        timer = setInterval(() => {if(step === 6){stop();return;}setStep(step+1);},3000);
      });
      document.addEventListener('visibilitychange', () => {if(document.hidden)stop();});
      reduced.addEventListener('change', stop);
      root.querySelectorAll('[data-paper-video]').forEach(link => link.addEventListener('click', event => {
        if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
        event.preventDefault();stop();
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + link.dataset.paperVideo + '?autoplay=1&rel=0';
        frame.title = link.dataset.videoTitle;frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;frame.referrerPolicy = 'strict-origin-when-cross-origin';
        link.closest('[data-video-frame]').replaceChildren(frame);frame.focus();
      }));
      const dialog = root.querySelector('[data-layout-dialog]');
      let opener = null;
      root.querySelectorAll('[data-layout-open]').forEach(link => link.addEventListener('click',event => {
        if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function')return;
        event.preventDefault();stop();opener = link;
        dialog.querySelector('[data-dialog-title]').textContent = link.dataset.layoutTitle;
        const img = document.createElement('img');img.src = link.href;img.alt = link.querySelector('img').alt;
        dialog.querySelector('[data-dialog-image]').replaceChildren(img);dialog.showModal();
      }));
      dialog.querySelector('[data-layout-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click',event => {if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}});
      dialog.addEventListener('close', () => {dialog.querySelector('[data-dialog-image]').replaceChildren();opener?.focus();});
    });
  };
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded', () => init());else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
